import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import { END_SESSION } from "@Broker/@Modules/main/store/account/account-actions";
import store from "../../store";
import { getCurrentColor, loadCSS, updateColours } from "@Shared/@Utils/utils";
import Amplitude from "@Shared/@Utils/amplitude";
import { ENVIRONMENT, ERROR_HEADER, showToast, TOASTR_ERROR_OPTIONS } from "@Shared/@Utils/constants";
import { ACCOUNT_STATUS } from "@Shared/js/constants";
import { EXTERNAL_SERVICE_NAME } from "@Shared/@Types/status-page/types";
export const allowIfPendingValidation = (to, from, next) => {
  const {
    accountDetails: {
      accountStatus
    }
  } = store.state.AccountStore;
  if (accountStatus !== ACCOUNT_STATUS.pendingEmailVerification) {
    next(false);
    return;
  }
  return true;
};
export const checkForSessionRedirects = (to, from, next) => {
  var _context;
  const {
    accountDetails: {
      accountStatus,
      accountType
    }
  } = store.state.AccountStore;
  if (accountStatus === ACCOUNT_STATUS.pendingEmailVerification) {
    next({
      name: "registration-verify"
    });
    return;
  }
  if (accountStatus === ACCOUNT_STATUS.pendingActivation) {
    store.dispatch(`AccountStore/${END_SESSION}`);
    next({
      name: "unverified"
    });
    return;
  }
  if (accountStatus === "trial-ended") {
    next({
      name: "trial-ended"
    });
    return;
  }
  if (_includesInstanceProperty(_context = to.path).call(_context, "agents") && accountType === "agent") {
    next({
      name: "home"
    });
    return;
  }
  return true;
};
export const verifySession = (to, from, next) => {
  const {
    token
  } = store.state.AccountStore;
  if (!token) {
    next({
      name: "login",
      query: {
        state: to.path || ""
      }
    });
    return;
  }
  return true;
};
export const checkForPayment = (to, from, next) => {
  const {
    accountDetails: {
      accountStatus
    }
  } = store.state.AccountStore;
  if (accountStatus !== "trial-ended") {
    next({
      name: "home"
    });
    return;
  }
  return true;
};
export const loadCustomStyles = () => {
  const {
    primary,
    secondary
  } = getCurrentColor();
  const {
    primary: storedPrimary,
    secondary: storedSecondary
  } = store.state.SettingsStore;
  if (storedPrimary && storedSecondary) {
    if (!store.getters["SettingsStore/GET_IS_ON_THEME_PREVIEW_MODE"] && (primary != storedPrimary || secondary != storedSecondary)) {
      updateColours(storedPrimary, storedSecondary);
    }
  }
  return true;
};
export const checkForRedirects = (to, from, next) => {
  const {
    accountDetails: {
      accountSubdomain
    }
  } = store.state.AccountStore;
  if (accountSubdomain && location.pathname.replace("/", "") !== accountSubdomain) {
    location.pathname = accountSubdomain;
    next(false);
    return;
  }
  return true;
};
export const loadAccountPlanLimits = async (to, from, next) => {
  try {
    var _to$meta;
    const page = (to == null ? void 0 : (_to$meta = to.meta) == null ? void 0 : _to$meta.accountPlanPage) || "";
    if (!page) return true;
    await store.dispatch("AccountPlanStore/LOAD_PLAN_LIMIT", page);
  } catch (error) {
    Amplitude.logHandledError(error, {}, "Error while loading plan details");
    next({
      name: "something-went-wrong"
    });
    return;
  }
  return true;
};
export const checkAccountPlanUsage = (page, routeRedirect) => {
  return (to, from, next) => {
    const usageRestricted = store.getters["AccountPlanStore/IS_USAGE_RESTRICTED"](page);
    if (usageRestricted) {
      next(routeRedirect);
      return;
    }
    return true;
  };
};
export const allowIfNoSession = (to, from, next) => {
  const {
    token
  } = store.state.AccountStore;
  if (token) {
    next({
      name: "home"
    });
    return;
  }
  return true;
};
export const loadCustomStylesSheet = async () => {
  if (document.getElementById("custom-styles-stylesheet")) return;
  const path = window.location.pathname.replace("/", "").replace("#", "");
  if (!path) return;
  const link = loadCSS(path, true);
  return new _Promise(resolve => {
    link.onload = () => {
      store.dispatch("AccountStore/LOAD_STYLES");
      resolve(true);
    };
    link.onerror = () => {
      showToast("error", "errorWhileLoadingStyles", ERROR_HEADER, TOASTR_ERROR_OPTIONS);
      resolve(true);
    };
  });
};
export const allowIfNotProduction = (to, from, next) => {
  if (ENVIRONMENT !== "test") {
    next(false);
    return;
  }
  return true;
};
export const checkIfGlobalMaintenanceMode = async (to, from, next) => {
  try {
    await store.dispatch("StatusPageStore/LOAD_EXTERNAL_SERVICES_STATUS", EXTERNAL_SERVICE_NAME.GLOBAL);
    const globalMaintenanceInProgress = store.getters["StatusPageStore/GLOBAL_MAINTENANCE_IN_PROGRESS"];
    if (globalMaintenanceInProgress && from.name === "maintenance-message") {
      next(false);
      return;
    }
    if (globalMaintenanceInProgress) {
      next({
        name: "maintenance-message"
      });
      return;
    }
  } catch (_unused) {}
  return true;
};